import { appUrl } from "../../constants/url-constants";

export const getCanonicalUrl = (pathname = "") => {
    if (!pathname) return "";
    let canonicalUrl = `${appUrl()}${pathname}`;
    if (pathname[pathname.length - 1] !== "/") {
        canonicalUrl += "/";
    }
    return canonicalUrl.toLowerCase();
};
